<script lang="ts">
    import ColorSymbol from '../../shared/ColorSymbol.svelte';
    import {_} from 'svelte-i18n';

    export let type: 'delivery' | 'collection' | null = 'delivery';
    export let scale: number = 1;
    export let color: string = '#60b9e6';
</script>

{#if color}
    <ColorSymbol {color} iconStyle="" {type} {scale} />
{/if}

